// Match actual display size without forcing supersampling on small screens.
export function sceneResolution(width, dpr = 1, compatible = false) {
  const target = (Number(width) || 1080) / 1080 * (Number(dpr) || 1);
  return Math.max(0.75, Math.min(compatible ? 1 : 2, Math.ceil(target * 4) / 4));
}
export function withDeadline(promise, milliseconds, stage) {
  let timer;
  return Promise.race([promise, new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error(stage + ': timeout')), milliseconds);
  })]).finally(() => clearTimeout(timer));
}
